import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { initNativePhoneAuth } from './services/firebase';
import { initNativeChrome } from './utils/nativeChrome';

initNativePhoneAuth();
initNativeChrome();

// reCAPTCHA Enterprise — site key from Firebase Console → Authentication → Settings
const recaptchaKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
if (recaptchaKey) {
  const script = document.createElement('script');
  script.src = `https://www.google.com/recaptcha/enterprise.js?render=${recaptchaKey}`;
  script.async = true;
  document.head.appendChild(script);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
